import React from 'react';
import Grid from '@mui/material/Grid';

/**
 * FormRow — responsive grid container for FormField children.
 *
 * Wraps MUI Grid v1 with `spacing={2}` (16 px). Uses Grid v1 because MUI
 * Unstable_Grid2 is not available until MUI 5.9. Migrating to Grid2 is a
 * one-line import swap inside this file.
 *
 * Convention: do NOT add mt / mb / marginBottom to individual FormFields —
 * the Grid spacing handles both axes uniformly.
 *
 * Usage:
 *   <FormRow>
 *     <FormField name="firstName" label="First Name" xs={12} sm={6} />
 *     <FormField name="lastName"  label="Last Name"  xs={12} sm={6} />
 *   </FormRow>
 *
 * Props:
 *   spacing  {number}  — Grid spacing (default 2 = 16 px)
 *   children {node}    — FormField(s) or any Grid item children
 *   sx       {object}  — extra sx on the Grid container
 */
export default function FormRow({ spacing = 2, children, sx, ...rest }) {
  return (
    <Grid container spacing={spacing} sx={sx} {...rest}>
      {children}
    </Grid>
  );
}
